import { workspaceLocales } from '@citrite/workspace-ui-platform';
import { ErrorConfigurationSchema } from 'CtxErrorMapper/errorConfigSchema';
import { platformToOSMap, RemediationOSName } from 'CtxErrorMapper/types';
import { getCurrentPlatform, isNativeClient } from 'Environment/launchResource/device';
import { detectLanguage } from 'javascript/sf/detectLanguage';

const defaultLocale = workspaceLocales.Default;
const defaultRemediationOSName = 'Wasm';

export abstract class ErrorMapperBase {
	protected constructor(
		protected readonly errorConfig: ErrorConfigurationSchema,
		protected readonly currentLocale = detectLanguage(),
		protected readonly remediationOSName: RemediationOSName = ErrorMapperBase.getRemediationOSName()
	) {}

	protected getLocalizedString(key: string): string {
		// check if { localized[locale]: {...} } object is available
		// else use { localized[defaultLocale]: {...} } as fallback
		const localizedStringsSection =
			this.errorConfig.localized[this.currentLocale] ||
			this.errorConfig.localized[defaultLocale];
		return localizedStringsSection[key];
	}

	public static getRemediationOSName(): RemediationOSName {
		if (!isNativeClient()) {
			return defaultRemediationOSName;
		}

		return platformToOSMap[getCurrentPlatform()] || defaultRemediationOSName;
	}
}
